import { WAREHOUSE_FEE_FAQ_ROUTE } from "@stadium/constants/external-routes";
import { LOCKER_INACTIVITY_FEE_TEXT } from "@stadium/constants/locker";

export const ADDRESS_TYPE_OPTIONS = {
  savedAddress: {
    key: "savedAddress",
    label: "Saved Address",
    lockerLabel: "These items will not appear in your Locker.",
  },
  newAddress: {
    key: "newAddress",
    label: "New Address",
    lockerLabel: "These items will not appear in your Locker.",
  },
  warehouseAddress: {
    key: "warehouseAddress",
    label: "Stadium Warehouse",
    subLabel: "United States",
    lockerLabel: `These items will be stored in our warehouse and will appear in your Locker once your purchase is confirmed. ${LOCKER_INACTIVITY_FEE_TEXT}`,
    learnMoreLink: WAREHOUSE_FEE_FAQ_ROUTE,
  },
};
